import { useRouter } from 'next/router';
import styled from 'styled-components';

import { UrlObject } from '../../../../types/__codegen__/sanity/graphql';
import constants from '../../../../ahm-constants';
import Nav from '../../../../elements/nav';

const defaultItems: UrlObject[] = [
  { name: 'Income Protection home', url: constants.URLS.SALES.INCOME_INSURANCE },
  { name: 'Life Insurance home', url: constants.URLS.SALES.LIFE_INSURANCE },
  { name: 'Make a claim', url: constants.URLS.SALES.LIFE_INSURANCE_CLAIM },
  { name: 'Contact us', url: constants.URLS.SALES.LIFE_INSURANCE_CONTACT_US },
  { name: 'Forms and guides', url: constants.URLS.SALES.LIFE_INSURANCE_USEFUL_DOCUMENTS },
];

const StyledNav = styled(Nav)`
  border: 2px solid ${({ theme }) => theme.colors.grey20};
`;

type LifeInsuranceNavProps = {
  className?: string;
  items?: UrlObject[];
};

const LifeInsuranceNav = ({ className, items = defaultItems }: LifeInsuranceNavProps) => {
  const { pathname } = useRouter();
  return (
    <StyledNav
      ariaLabel="Life Insurance Content Navigation"
      className={className}
      items={items
        .filter((item) => item.name && item.url)
        .map((item) => ({
          isActive: pathname === item.url,
          name: item.name as string,
          url: item.url as string,
        }))}
    />
  );
};

export default LifeInsuranceNav;
